/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ muscle: NonNullable<unknown>, date: NonNullable<unknown> }} Profile_Excluded_MetaInputs */

const en_us2_profile_excluded_meta = /** @type {(inputs: Profile_Excluded_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} · out since ${i?.date}`)
};

const pt_br2_profile_excluded_meta = /** @type {(inputs: Profile_Excluded_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} · fora desde ${i?.date}`)
};

const es_419_profile_excluded_meta = /** @type {(inputs: Profile_Excluded_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} · fuera desde el ${i?.date}`)
};

const pt_pt2_profile_excluded_meta = /** @type {(inputs: Profile_Excluded_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} · fora desde ${i?.date}`)
};

const fr_fr2_profile_excluded_meta = /** @type {(inputs: Profile_Excluded_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} · exclu depuis le ${i?.date}`)
};

const de_de2_profile_excluded_meta = /** @type {(inputs: Profile_Excluded_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} · raus seit ${i?.date}`)
};

const it_it2_profile_excluded_meta = /** @type {(inputs: Profile_Excluded_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} · escluso dal ${i?.date}`)
};

/**
* | output |
* | --- |
* | "{muscle} · out since {date}" |
*
* @param {Profile_Excluded_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_excluded_meta = /** @type {((inputs: Profile_Excluded_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Excluded_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_excluded_meta(inputs)
	if (locale === "es-419") return es_419_profile_excluded_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_excluded_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_excluded_meta(inputs)
	if (locale === "de-DE") return de_de2_profile_excluded_meta(inputs)
	if (locale === "it-IT") return it_it2_profile_excluded_meta(inputs)
	return en_us2_profile_excluded_meta(inputs)
});
export { profile_excluded_meta as "profile.excluded_meta" }